// @flow

import React from 'react';
import { InView } from 'react-intersection-observer';
import type { ACFProps } from './types';
import { ACFButton } from '../button';
import Image from '../image';
import {
  IconTop,
  IconTopBoxed,
  IconFullWidth,
  IconLeft,
  IconLeftBoxed,
} from './iconText';


const getIconTextComponent = (variant: string, boxed: boolean, size: string) => {
  switch (variant) {
    case 'left':
      if (boxed) {
        return IconLeftBoxed;
      }
      return IconLeft;

    case 'left_boxed':
      return IconLeftBoxed;

    case 'boxed':
      return IconTopBoxed;

    case 'full_width':
      return IconFullWidth;

    default:
      if (boxed) {
        return IconTopBoxed;
      }
      if (size === 'full_width') {
        return IconFullWidth;
      }
      return IconTop;
  }
};

const IconText = ({
  boxed,
  title,
  subtext,
  size,
  button_enabled,
  button,
  variant,
  icon_uploaded,
}: ACFProps) => {
  // const buttonComponent = buttonProps => (<ACFButton />);
  const IconTextComponent = getIconTextComponent(variant, boxed, size);
  return (
    <IconTextComponent
      iconComponent={
        <InView>
          {({ inView, ref }) => (
            <div ref={ref}>
              {inView && (<Image src={icon_uploaded} alt={title} position="center" />)}
            </div>
          )}
        </InView>
      }
      iconUploaded={icon_uploaded}
      title={title}
      description={subtext}
      largeIcon={size === 'large'}
      buttonComponent={button_enabled && button
        ? (
          <ACFButton
            icon={button.icon}
            position={button.position}
            size={button.size}
            template={button.template}
            text={button.text}
            page={button.page}
            url={button.url}
            with_icon={button.with_icon}
            type={button.type}
            hash={button.hash}
          />
        )
        : null}
    />
  );
};

export default IconText;
